module.exports = __webpack_public_path__ + "img/404_img.a5163d6.jpg";